import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import axios from "axios/index";

import Header from '../../../Header/index';
import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import PageNotFound from '../../../../components/PageNotFound/pageNotFound';
import { Spinner } from '../../../../components/Loading/Spinner';
import { reloadedTrip } from '../../../../actions/trip_actions';
import helpers from '../../../../utils/helpers';

import TripSteps from './TripSteps';
import TripTruckEntry from './TripTruckEntry';

import TripWaitingScale from './TripWaitingScale';
import TripClosed from './Done/';
import TripRejectModal from './TripRejectModal';
import TripProgrammingForm from './TripProgrammingForm';

import TripProgrammingFormDone from './Done/TripProgrammingForm';
import TripAudit from "../../Trips/Trip/TripAudit";

class Trip extends Component {

    constructor(props) {
        super(props);

        const {fetchedTrip} = this.props;

        this.state = {
            trip: fetchedTrip,
            tripId: fetchedTrip.id,
            ajaxInProgress: false,
            activeStep: null
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.trip && nextProps.trip.trip_updated){
            this.setState({trip: false}, this._fetchTrip);
        }
    }

    _fetchTrip = () => {
        // To reload trip
        if(this.state.trip){this.setState({trip: false});};

        let {tripId} = this.state;
        if(!tripId || isNaN(tripId)){return false;}

        let TRIP_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.tripId}/`;
        axios
            .get(TRIP_URL, tokenHeader())
            .then(response => {
                this.setState({trip: response.data, activeStep: null}, this.props.reloadedTrip);
            })
            .catch(error => {
                try{
                    let response = error.response;
                    if(response.status === 404){
                        // To redirect user to 404 page, set a non-existant id
                        this.setState({tripId: 'idNotFound'})
                    }else{
                        ajaxHandler(error);
                    }
                }
                catch (e){
                    ajaxHandler(error);
                }
            });
    };

    _changeStep = (step) => {
        this.setState({activeStep: step.code})
    };

    render() {
        let {trip, tripId, activeStep} = this.state;

        // Security check
        if(!this.props.user || !tripId || isNaN(tripId)){
            return <PageNotFound />;
        }

        // Waiting for options
        if(!trip){
            return (
                <div className={"main-dashboard"}>
                    <Header active={"new-trip"} />
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>
            );
        }

        // Trip data
        let status = trip.status.id;

        // Trips steps
        let currentStep = 0;

        // Trip logic for render
        let body = <div>Case not ready:<br />Status: {status}</div>;
        let showRejectionButton = false;
        let activeTrip = true;

        switch(status){
            case 'A4':
            case 'B0':
            case 'B4':
            case 'E1':
                body = <TripTruckEntry trip={trip} />;
                currentStep = 1;
                break;
            case 'D0':
                body = <TripWaitingScale message={"Esperando balanza de Salida"} title={"Balanza de Salida"} />;
                currentStep = 2;
                break;
            case 'D1':
            case 'D5':
            case 'E6':
                body = <TripClosed trip={trip} />;
                currentStep = 7;
                activeTrip = false;
                break;
            default:
                break;
        }

        // If user changed active Step, render done body
        if(activeStep){
            switch(activeStep){
                case 'initial':
                    body = <TripProgrammingFormDone trip={trip} boxed={true} />;
                    if(helpers.canUserEditInternalTrip(this.props.user) && ['A4', 'E1'].indexOf(status) > -1){
                        body = <TripProgrammingForm trip={trip} reloadTrip={this._fetchTrip} />;
                    }
                    break;
                case 'entry':
                    if(status !== 'B0')
                        body = <TripTruckEntry trip={trip} />;
                    break;
                case 'exit':
                    // Last step. Nothing to do
                    break;
                default:
                    break;
            }
        }

        if(helpers.canUserReject(this.props.user) && status === 'C0'){
            showRejectionButton = trip.discharge.length === 0;
        }

        let exitStates = ['E5'];

        return (
            <div>
                <div className={"main-dashboard"} style={{paddingBottom: '100px'}}>
                    <Header active={helpers.trip_type.INTERNAL}/>
                    {exitStates.indexOf(status) === -1 &&
                    <TripSteps steps={helpers.tripSteps.INTERNAL} currentStep={currentStep}
                               changeAction={this._changeStep}
                               activeStep={this.state.activeStep}
                               activeTrip={activeTrip} />}
                    {status === 'E5' &&
                    <h3 className={'shell-red-text center'}> Viaje Rechazado </h3>
                    }
                    {helpers.isUserAdmin(this.props.user) &&
                    <TripAudit trip={trip} user={this.props.user} />
                    }

                    {body}
                    {showRejectionButton && <TripRejectModal trip={trip} reloadTrip={this._fetchTrip} />}
                </div>
            </div>
        );
    }
}


const
    mapStateToProps = (state) => {
        return {
            user: state.user,
            trip: state.trip
        }
    };

const
    mapDispatchToProps = (dispatch) => {
        return bindActionCreators({reloadedTrip}, dispatch);
    };

export default connect(mapStateToProps, mapDispatchToProps)(Trip);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/index.js